import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import {generateRoutePath} from 'epic-common/src/route';

const NewsItem = ({data, isMobile}) => {
    const {title, date, slug, locale, image, trendImage, externalLink} = data;
    const dateOptions = {month: 'short', year: 'numeric', day: 'numeric'};
    const dateString = date ? (new Date(date).toLocaleDateString(locale.replace(/_/g, '-'), dateOptions)) : '';
    const bkImage = isMobile ? trendImage || image : image || '';
    
    if (externalLink) {
        return (
            <a href={externalLink} className="news-item">
                <div className="image-container">
                    <div className="image" style={image ? {backgroundImage: `url(${bkImage})`} : null} />
                </div>
                <div className="content">
                    <p>{dateString}</p>
                    <h3>{title}</h3>
                </div>
            </a> 
        );
    }

    return (
        <Link to={generateRoutePath(`/news/${slug}`)} className="news-item">
            <div className="image-container">
                <div className="image" style={image ? {backgroundImage: `url(${bkImage})`} : null} />
            </div>
            <div className="content">
                <p>{dateString}</p>
                <h3>{title}</h3>
            </div>
        </Link>
    );
};
NewsItem.propTypes = {
    data: PropTypes.object,
    isMobile: PropTypes.bool
}

export default NewsItem;
